import request from '@/api/request'
import Base64 from "js-base64";
import store from '@/store/'
// import { MyRoleInfo } from '@/store/modules/profile/types';
const urlLogin = "/api/manager/login/login";
const urlLogout = "/api/manager/login/logout";

export function loginApi(username: string, password: string) {
  const serverUrl = urlLogin;

  const data = {
    "u": username,
    "p": Base64.Base64.encode(password)
  }
  return request({
    url: serverUrl,
    method: 'post',
    data
  })
}
export function logoutApi() {
  const serverUrl = urlLogout;

  return request({
    url: serverUrl,
    method: 'post'
  })
}

// 获取详细用户信息
export function getUserInfoApi() {
  const serverUrl = "/api/manager/login/userinfo";

  return request({
    url: serverUrl,
    method: 'get'
  })
}

export function checkServer() {

  const serverUrl = "/api/manager/login/checkserver";

  return request({
    url: serverUrl,
    method: 'get'
  })
}



// const whiteSites = ["account", "pages"];
// const webManagerSites = ["workplatform", "topic", "directtrain",
//   "banner", "book", "sportsvideo", "culture", "question","shsports"
// ];
// const contentSites = ["article", ];
// const systemManagerSites = ["company", "muser", "role"];
// const reviewSites = ["review"];
// const dataSites = ["stat"];

export function checkPermission(to: { path: string }) {
  if (!to || to.path === '/' || to.path === '/dashboard')
    return true;
  // let roleInfo:MyRoleInfo = store.getters["profileModule/roleinfos"];
  // if(roleInfo.isadmin){
  //   return true;
  // }

  return true;
  
  // if(roleInfo.hasPer0001){
  //   console.log("has permission manager")
  // }

}